import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=43d4eae2&scoped=true&"
import script from "./Tag.vue?vue&type=script&lang=ts&"
export * from "./Tag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d4eae2",
  null
  
)

export default component.exports